import { Component, Inject, Input } from "@angular/core";
import { CommonModule } from '@angular/common';
import { FieldOkItemComponent } from "@softline/dynamic";

@Component({
    selector: 'soft-field-ok-data-view',
    imports: [CommonModule],
    templateUrl: './arteh.list-view.html',
    styleUrls: ['./arteh.list-view.scss']
})
export class ArtehListView implements FieldOkItemComponent<any>{

  @Input() item: any;

  constructor() {
  }
}
